import AdminSidebar from "components/admin/AdminSidebar";
import AdminHeader from "components/admin/AdminHeader";
import { SidebarProvider } from "components/ui/sidebar";
import { Toaster } from "components/ui/sonner";
import { useState } from "react";
import type { ReactNode } from "react";

type AdminLayoutProps = {
  children: ReactNode;
  title: string;
  subtitle?: string;
  action?: ReactNode;
};

const AdminLayout = ({ children, title, subtitle, action }: AdminLayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <SidebarProvider className="intrex-admin-scope flex min-h-screen w-full font-Inter">
      <Toaster />
      <aside
        className={`
          transition-[width] duration-200 ease-linear
          bg-brand-sidebar
          ${sidebarOpen ? "w-[240px]" : "w-0"}
        `}
      >
        <AdminSidebar />
      </aside>

      <div className="flex flex-1 flex-col max-h-screen">
        <AdminHeader
          sidebarOpen={sidebarOpen}
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          title={title}
          subtitle={subtitle}
          action={action}
        />

        <main className="flex-1 bg-brand-bg text-brand-text overflow-scroll p-6 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          {children}
        </main>
      </div>
    </SidebarProvider>
  );
};

export default AdminLayout;
